import React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';

const NavStyles = styled.nav`
  ul {
    text-align: center;
    list-style: none;
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    padding: 0 20px;
  }

  a {
    color: var(--taupe);
  }
  h2 {
    color: var(--black);
  }
`;

const HomeStyle = styled.h3`
  a {
    color: var(--black);
  }
`;

export default function Nav() {
  return (
    <NavStyles>
      <ul>
        <li>
          <HomeStyle>
            <Link to="/">Ceramoni</Link>
          </HomeStyle>
        </li>
        {/* <li>
          <Link to="/stone-index">Stone Library</Link>
        </li>
        <li>
          <Link to="/roots">Roots</Link>
        </li> */}

        <li>
          <Link to="/browse">Browse</Link>
        </li>
        {/* <li>
          <Link to="/consultations">Consult</Link>
        </li> */}
        {/* <li>
          <Link to="/menu">Menu</Link>
        </li> 
        <li>
          <button class="snipcart-checkout">View cart</button>
        </li> */}
      </ul>
    </NavStyles>
  );
}
